import styled from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import { h2Style, h5Style, h6Style } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";

export const Column = styled(Flex.Col)`
    margin-bottom: ${theme.space[5]}px;
`;

export const Wrapper = styled.div`
    position: relative;
    min-height: 100%;
    background-color: ${theme.colors.mist};
`;

export const SubmodelImageWrapper = styled.div`
    padding: 0 ${theme.space[3]}px;
    background: rgb(244, 246, 251);
    background: linear-gradient(0deg, rgba(244, 246, 251, 1) 40%, rgba(255, 255, 255, 1) 40%);
    @media ${getBreakpoint("up", "lg")} {
        padding: 0 60px;
    }
`;

export const SubmodelWrapper = styled.div`
    padding: ${theme.space[6]}px ${theme.space[3]}px 80px; /* 40 extra padding bottom for absolute buttons */
    background-color: ${theme.colors.mist};
    @media ${getBreakpoint("up", "lg")} {
        padding: ${theme.space[6]}px ${theme.space[6]}px 120px; /* 40 extra padding bottom for absolute buttons */
    }
`;

export const SubmodelButtonWrapper = styled.div`
    position: absolute;
    bottom: ${theme.space[3]}px;
    left: 0;
    width: 100%;
    padding: 0 ${theme.space[3]}px;
    @media ${getBreakpoint("up", "lg")} {
        bottom: 60px;
        padding: 0 ${theme.space[6]}px;
    }

    html[dir="rtl"] & {
        left: auto;
        right: 0;
    }
`;

export const Header = styled.div`
    margin-bottom: ${theme.space[3]}px;
    padding: 0 0 ${theme.space[3]}px;
    border-bottom: 1px solid ${theme.colors.platinumMedium};
`;

export const SubmodelTitle = styled.h2.attrs(() => ({
    className: "l-beta-text",
}))`
    margin-bottom: 0;
    text-transform: none;
    ${h2Style};
    color: ${theme.colors.black};
`;

export const EngineLabel = styled.div`
    text-transform: uppercase;
    color: ${theme.colors.brushedSteel};
    ${h6Style};
`;

export const LabelFrom = styled.div`
    color: ${theme.colors.brushedSteel};
`;

export const Price = styled.div`
    margin-bottom: ${theme.space[3]}px;
    color: ${theme.colors.black};
    ${h5Style};
`;

export const Description = styled.div`
    margin-bottom: ${theme.space[3]}px;
    color: ${theme.colors.platinumDark};
`;
